import { createContext } from "react"

type CoManagerDrawerControls = { open: () => void } | null

/**
 * Opens the co-manager drawer from wherever its button is, the header or the floating one on pages
 * without a header. Null outside the master template, where the button falls back to the page.
 */
export const CoManagerDrawerContext = createContext(null as CoManagerDrawerControls)
